"use client";

import CatalogPage from "./catalog/page";

export default function Home() {
  return <CatalogPage />;
}
